import { useTranslation } from "react-i18next";
import React, { useState } from "react";

export function LoadingScreen() {
  const { t } = useTranslation();
  return (
    <div
      className="flex min-h-[60vh] items-center justify-center"
      role="status"
      aria-label={t("common.loading")}
    >
      <span className="size-10 animate-spin rounded-full border-4 border-navy-100 border-t-navy-700" />
    </div>
  );
}
